import { COLORS } from '../constants/theme';
import { loadImageBase64 } from '../utils/imageLoader';

const formatDateSigned = (dateStr) => {
    let d = new Date();
    if (dateStr) {
        if (typeof dateStr === 'string' && dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [y, m, day] = dateStr.split('-');
            return `${m}-${day}-${y}`;
        }
        if (typeof dateStr === 'string' && dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
            const [day, m, y] = dateStr.split('-');
            return `${m}-${day}-${y}`;
        }
        const parsed = new Date(dateStr);
        if (!isNaN(parsed.getTime())) {
            d = parsed;
        }
    }
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
};

export const drawSignature = async (engine, signature, dateSigned) => {
    const doc = engine.getDoc();
    const cursor = engine.getCursor();

    const sigBoxY = cursor.getY() + 20; // 20pt gap after summary line

    doc.setDrawColor(...COLORS.LINE_MEDIUM);
    doc.setLineWidth(0.75);
    doc.rect(36, sigBoxY, 540, 60, 'S'); // Outer box
    doc.line(376, sigBoxY, 376, sigBoxY + 60); // Vertical separator

    // Box headers
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("CUSTOMER SIGNATURE", 46, sigBoxY + 15);
    doc.text("ORDER DATE", 386, sigBoxY + 15);

    // Horizontal underline for signing and dating
    // doc.setDrawColor(...COLORS.LINE_LIGHT);
    // doc.setLineWidth(0.5);
    // doc.line(46, sigBoxY + 42, 356, sigBoxY + 42);
    // doc.line(386, sigBoxY + 42, 566, sigBoxY + 42);

    // Labels underneath underline
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.TEXT_LIGHT);
    // doc.text("Digitally signed", 46, sigBoxY + 53);
    // doc.text("MM / DD / YYYY", 386, sigBoxY + 53);

    // Current Date value rendered above underline (formatted MM / DD / YYYY)
    const displayDate = formatDateSigned(dateSigned);
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text(displayDate, 386, sigBoxY + 38);

    // Signature image if available sitting above underline
    if (signature) {
        try {
            const sigImgData = await loadImageBase64(signature);
            if (sigImgData && sigImgData.base64) {
                const maxWidth = 200;
                const maxHeight = 24;
                const ratio = (sigImgData.width && sigImgData.height) ? sigImgData.width / sigImgData.height : 3;
                let renderWidth = maxWidth;
                let renderHeight = maxHeight;

                if (ratio > maxWidth / maxHeight) {
                    renderWidth = maxWidth;
                    renderHeight = maxWidth / ratio;
                } else {
                    renderHeight = maxHeight;
                    renderWidth = maxHeight * ratio;
                }

                // Left-aligned at x=46, sitting on the line (bottom at sigBoxY + 41)
                const xOffset = 46;
                const yOffset = sigBoxY + 41 - renderHeight;

                doc.addImage(sigImgData.base64, 'PNG', xOffset, yOffset + 5, renderWidth, renderHeight);
            } else {
                let renderSig = signature;
                if (typeof renderSig === 'string' && !renderSig.startsWith('data:') && !renderSig.startsWith('http') && !renderSig.startsWith('/')) {
                    renderSig = 'data:image/png;base64,' + renderSig;
                }
                doc.addImage(renderSig, 'PNG', 46, sigBoxY + 16, 200, 24);
            }
        } catch (e) { }
    }

    // Draw page number at bottom of current summary page
    engine.getPageManager().drawPageFooterNumber();

    const endY = sigBoxY + 60;
    cursor.setY(endY);
    return endY;
};
